<div class="layout-content">
	<!-- PROGRESS SPINNER -->
	<div *ngIf="exporting || updating">
		<div class="flex align-items-center justify-content-center w-full pb-8">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
	</div>
	<!-- FORM -->
	<form *ngIf="!exporting && !updating" (ngSubmit)="submit()" [formGroup]="addboarduserListForm">
		<div class="grid">
			<!-- ALERT MISMATCH / MATCH VERSIONS -->
			<!-- <div *ngIf="mismatchVersionsLists()" class="col-12 mb-3 flex align-items-center justify-content-center bg-yellow-200 py-1 border-round-xl">
				<i class="pi cm-alert text-2xl text-yellow-700 mx-2"></i>
				<div class="flex flex-column">
					<p-tag [value]="('ALERT_MISMATCH_VERSIONS' | translate)" severity="warning" styleClass="py-1"></p-tag>
					<p-tag [value]="('ADVICE_RELOAD_PAGE' | translate)" severity="warning" styleClass="py-1"></p-tag>
				</div>
			</div>
			<div *ngIf="!mismatchVersionsLists()" class="col-12 mb-3 flex align-items-center justify-content-center bg-green-200 p-1 border-round-xl">
				<i class="pi cm-check text-xl text-green-700 mx-2"></i>
				<p-tag value="{{'NOTE_MATCH_VERSIONS' | translate}}" severity="success"></p-tag>
			</div> -->
			<!-- INPUTS -->
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME_LIST' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText
							[ngClass]="dynamicInputTextWidth()"
							id="scenery-add-input-name"
							formControlName="name"
							autocomplete="scenery-name"
							placeholder="{{ 'NAME_LIST' | translate }}"
							maxlength="26"
						/>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'INSERT_ATLEAST_5CHARS' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple
				label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mx-2"
				[ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()"
				label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mx-2"
				[ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>
